import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="mx-auto max-w-lg px-4 py-28 text-center sm:px-6">
      <p className="font-display text-6xl font-semibold text-gold-300">404</p>
      <h1 className="mt-6 font-display text-2xl font-semibold text-ink-900">
        We could not find that page
      </h1>
      <p className="mt-3 text-lg text-ink-900">
        It may have been moved or removed when the site was rebuilt.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex rounded-lg bg-ink-800 px-6 py-3 text-lg font-medium text-white transition-colors hover:bg-ink-900"
      >
        Back to home
      </Link>
    </div>
  );
}
